import instance from '@/utils/axios';

/**
 * 获取报警类型
 */
export function getAlarmType(data) {
  return instance.post('/baseinfo/alarmType', data);
}

/**
 * 获取物质的详情
 * @param {物质ID} materialId
 */
export function materialInfo(materialId) {
  return instance.get('/baseinfo/materialDetail', {
    params: {
      materialId
    }
  });
}
/**
 * 获取物质类型
 */
export function getMaterialType() {
  return instance.post('/baseinfo/materialType');
}

/**
 * 查询当下机构或者任务下的设备
 */

export function getDevicesList(data) {
  return instance.post('/baseinfo/deviceInfo', data);
}

/**
 * busiType 业务类型：1-报警统计，2-检测统计，3-设备状态统计，4-原始数据统计，5-原始报表统计
 * dataType 数据类型：0-全部，1-按机构，2-按任务
 * 获取统计类型
 */

export function getStatType(data) {
  return instance.get('/baseinfo/statType', {
    params: {
      ...data
    }
  });
}

/**
 * busiType 1-报警统计，2-检测统计，3-设备状态统计，10-监测记录查询，11-历史报警查询，12-检测记录查询，13-设备状态查询
 */

export function getDeviceModels(data) {
  return instance.get('/baseinfo/deviceModel', {
    params: {
      ...data
    }
  });
}
